// extracted by mini-css-extract-plugin
export const title = "Services-module--title--1I2CP";
export const projects_container = "Services-module--projects_container--3OAL5";
export const projects_title = "Services-module--projects_title--1wOi_";
export const article_img_container = "Services-module--article_img_container--JzfOH";
export const project_img_container = "Services-module--project_img_container--3eyaj";
export const bouncy = "Services-module--bouncy--1pc4Z";
export const pop = "Services-module--pop--3TWLA";